"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/hooks/usePollQuery.ts
var usePollQuery_exports = {};
__export(usePollQuery_exports, {
  MAX_RETRY: () => MAX_RETRY,
  usePollQuery: () => usePollQuery
});
module.exports = __toCommonJS(usePollQuery_exports);
var import_react = require("react");
var import_react_use = require("react-use");
var MAX_RETRY = 6;
function usePollQuery(refetch, options) {
  const { fetching, error, delay } = options;
  const [retryCount, setRetryCount] = (0, import_react.useState)(0);
  const disabled = fetching || retryCount >= MAX_RETRY;
  const onInterval = (0, import_react.useCallback)(() => {
    if (error) {
      setRetryCount((n) => n + 1);
    } else if (retryCount > 0) {
      setRetryCount(0);
    }
    refetch({ requestPolicy: "network-only" });
  }, [refetch, setRetryCount, error, retryCount]);
  (0, import_react_use.useInterval)(onInterval, disabled ? null : delay);
  return {
    retryCount
  };
}
